var _g, _defs, _setting;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathAnimateSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Path-animate-svg",
    width: 407,
    height: 342,
    viewBox: "0 0 407 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6206_256966)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6206_256966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.433594 78.5C43.8991 62.586 105.498 82.9299 105.498 154.999C105.498 264.999 131.998 340.499 200.998 340.499C269.998 340.499 278.498 268 278.498 131.5C278.498 30.8134 338.701 -16.5069 406 7.32154",
    stroke: "#B8B8BB",
    strokeWidth: 2,
    strokeDasharray: "0,0,0,849.1314697265625"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: "indefinite",
    dur: "7.142857142857143s",
    values: "0,0,0,849.1314697265625;            0,424.56573486328125,424.56573486328125,0;            849.1314697265625,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6206_256966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 407,
    height: 342,
    fill: "white",
    strokeDasharray: "0,0,0,1498"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: "indefinite",
    dur: "7.142857142857143s",
    values: "0,0,0,1498;            0,749,749,0;            1498,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6206_256966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 407,
    height: 342,
    fill: "white",
    strokeDasharray: "0,0,0,1498"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: "indefinite",
    dur: "7.142857142857143s",
    values: "0,0,0,1498;            0,749,749,0;            1498,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))))), _setting || (_setting = /*#__PURE__*/React.createElement("setting", null, "{\"type\":\"indefinite\",\"speed\":7,\"random\":1,\"shift\":1,\"size\":1,\"rupture\":50}")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathAnimateSvg);
export default __webpack_public_path__ + "static/media/Path-animate-svg.ee4eaba1ca8aa8c1efd0c8cb257beffc.svg";
export { ForwardRef as ReactComponent };